import { Button, Menu } from "antd";
import ProductDropdown from "../Performance Dashboard/productsDropdown";
import { PlusOutlined } from "@ant-design/icons";

interface ITeamConfigFilter {
    menuItems: any[]
    menuCSS: React.CSSProperties
    handleSelectTeam: (team: any) => void
    handleNewTeam: (team: any) => void
    selectedTeam: any
}

const TeamConfigFilter = (props: ITeamConfigFilter) => {
    const { menuItems, menuCSS, handleSelectTeam, handleNewTeam, selectedTeam } = props;
    
    return (
        <div className="team-config-filters">
            <h1 className="page-heading p-10">Team Configuration</h1>
            <div className='mb-2 border-bottom-grey p-[15px]'>
                <ProductDropdown />
            </div>
            <div className="sider-wrapper">
                <Menu
                    mode="inline"
                    theme="light"
                    selectedKeys={[`${selectedTeam?.id}`]}
                    style={{ ...menuCSS, height: "100%" }}
                    items={menuItems}
                    onClick={({ key }) => {
                        handleSelectTeam(key);
                    }}
                />
            </div>
            <div className="absolute bottom-[2%] ml-5">
                <Button
                    size="large"
                    className="add-team-side-btn"
                    icon={<PlusOutlined />}
                    onClick={handleNewTeam}
                >
                    New Team
                </Button>
            </div>
        </div>
    )
}

export default TeamConfigFilter;